import { useLocation, useNavigate } from "react-router-dom";
import UserLayout from "../components/UserLayout";

const ExcelDataPage = () => {
  const location = useLocation();
  const { data } = location.state || { data: [] }; // Retrieve the data passed from the previous page
  const navigate = useNavigate(); // To navigate back to the previous page

  const handleGoBack = () => {
    navigate(-1); // This will navigate to the previous page
  };

const getBoldStyleForHeader = (header) => {
  return header 
    
    ? {
        fontWeight: "bold",  // Apply bold style
        width: "100px",      // Set width to make the header column wider
      }
    : {};
};
const formatToCurrency = (value) => {
  if (!isNaN(value)) {
    return new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    }).format(value);
  }
  return ""; // Nếu không phải số, trả về chuỗi rỗng
};

const getBoldStyleForData = (colIndex, cell, rowLength, rowIndex) => {
  console.log(`Row ${rowIndex}, Column ${colIndex}, Cell Value:`, cell);

  // Apply bold style if the cell content is specific
  const isFirstColumn = colIndex === 0; // Check if it's the first column
  const isLastColumn = colIndex === rowLength - 1; // Check if it's the last column

  // Apply bold style for specific headers or first/last column
  const style = {
    ...(String(cell).trim() === "Mã đơn" ||
    String(cell).trim() === "STT" ||
    String(cell).trim() === "Ngày tạo đơn" ||
    String(cell).trim() === "Line" ||
    String(cell).trim() === "Mã vận đơn TQ" ||
    String(cell).trim() === "Mã vận đơn VN" ||
    String(cell).trim() === "Tên sản phẩm" ||
    String(cell).trim() === "Số Kiện" ||
    String(cell).trim() === "KG/M3" ||
    String(cell).trim() === "Đ.Vị" ||
    String(cell).trim() === "Bảo Hiểm" ||
    String(cell).trim() === "Chi phí khác" ||
    String(cell).trim() === "Phương Thức Lấy Hàng" ||
    String(cell).trim() === "Ghi chú" ||
    String(cell).trim() === "Trạng Thái" ||
    String(cell).trim() === "Tổng cước"
    ) ? { fontWeight: "bold", backgroundColor: "yellow" } : {},

    // Apply bold for "Ngày đối soát:", "KH:", "Tổng đơn:", and "Tổng phí:"
    ...(String(cell).trim() === "Ngày đối soát:" ||
      String(cell).trim() === "KH:" ||
      String(cell).trim() === "Tổng đơn:" ||
      String(cell).trim() === "Tổng phí:"
    ) ? { fontWeight: "bold" } : {},
 ...(String(cell).trim() === "M3" || String(cell).trim() === "KG"
      ? { width: "80px" }  // Set the width for M3 and KG cells
      : {}),
    ...(isFirstColumn ) ? { width: "10px" } : {}, // Increase width for first and last column
  ...(colIndex === 2 && rowIndex === 1
      ? { color: "red", fontWeight: "bold" ,  className: "center-text" }  // Apply both red and bold styling
      : {}),

      // ...(colIndex === 3 && String(cell).trim() !== "Line"  
      // || colIndex === 13 && String(cell).trim() !== "Ghi chú"  || colIndex === 12 && String(cell).trim() !== "Phương Thức Lấy Hàng"
      // || colIndex === 14 && String(cell).trim() !== "Trạng Thái" 
      //    || colIndex === 6 && String(cell).trim() !== "Tên sản phẩm"
      // ? { textAlign: "left",  }  // Apply both red and bold styling
      // : {}),

      // ...(colIndex === 2 && String(cell).trim() !== "Ngày tạo đơn" || colIndex === 2 && rowIndex !== 1
   
      // ? { textAlign: "right",  }  // Apply both red and bold styling
      // : {}),
      ...(colIndex === 4 && rowIndex === 0
      ? { color: "red", fontWeight: "bold"  , textAlign:"center" }  // Apply both red and bold styling
      : {}),
       ...(colIndex === 2 && rowIndex === 0
      ? { color: "red", fontWeight: "bold", textAlign:"center" }  // Apply both red and bold styling
      : {}),
       ...(colIndex === 2 && rowIndex === 2
      ? { color: "red", fontWeight: "bold" }  // Apply both red and bold styling
      : {}),
  };

  return style;
};

  return (
    <div>
      <UserLayout>
      <div
        style={{
          maxHeight: "554px", // Giới hạn chiều cao của bảng
          overflowY: "auto", // Thêm thanh cuộn dọc
        }}
      >
        
        <table
          className="table table-bordered"
          style={{ borderCollapse: "collapse", width: "100%" }}
        >
          <thead>
    <tr>
  {/* Add two <td> elements before the header cells */}
<td
  colSpan={2} // Spanning across two columns
  style={{
    borderRight: "1px solid black", // Apply right border to the combined cell
     borderLeft: "1px solid black", // Apply right border to the combined cell
    padding: "8px", // Apply padding inside the cell
  }}
>
  {/* Content for the combined cell (if any) */}
</td>
  

  {data[0] && (
    <td
      colSpan={data[0].length +2} // Span across all columns based on the number of headers
      style={{
        textAlign: "center",
        border: "1px solid black",
        padding: "8px",
        fontWeight: "bold", // Applying bold to the entire combined header
        width: "auto", // Ensure the width is applied correctly
        position: "static", // Remove sticky positioning
        top: "auto", // Reset top position
        zIndex: "auto", // Reset z-index
      }}
    >
      {/* Combine all headers into one cell */}
      {data[0].map((header, index) => (
        <span key={index} style={{ marginRight: "10px" }}>
          {header}
        </span>
      ))}
    </td>
  )}
   
</tr>
          </thead>
          <tbody>
            {data.slice(1).map((row, rowIndex) => (
              <tr key={rowIndex}>
                 {(rowIndex === 0 || rowIndex === 1 || rowIndex === 2) && (
        <td
          colSpan={2}
          style={{
            borderLeft: "1px solid black",
            borderRight: "1px solid black",
            borderTop: rowIndex === 0 ? "none" : "none", // Only Row 1 has a top border
            borderBottom: "", // All rows have a bottom border
            padding: 0,
          }}
        ></td>
      )}


                {row.map((cell, colIndex) => (
                  <td
                    key={colIndex}
                    style={{
                      wordWrap: "break-word",
                      textAlign: "center",
                      border: "1px solid black",
                      padding: "8px",
                      ...getBoldStyleForData(colIndex, cell, row.length, rowIndex), 
                    }}
                  >
                    {cell}
                  </td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div style={{ display: "flex", justifyContent: "center" }}>
        <button
          className="btn btn-secondary btn-sm m-3"
          onClick={handleGoBack}
        >
          Quay lại
        </button>
      </div>

      </UserLayout>

    </div>
  );
};

export default ExcelDataPage;
